// contexts/VideoContext.tsx
import React, { createContext, useContext, useEffect, useState } from "react";

interface VideoContextType {
    mutedVideo: boolean;
    setMutedVideo: React.Dispatch<React.SetStateAction<boolean>>;
}

const VideoContext = createContext<VideoContextType | null>(null);

export const VideoProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [mutedVideo, setMutedVideo] = useState(() => {
        return localStorage.getItem("mutedVideo") === "true";
    });

    useEffect(() => {
        localStorage.setItem("mutedVideo", String(mutedVideo));
    }, [mutedVideo]);

    return (
        <VideoContext.Provider value={{ mutedVideo, setMutedVideo }}>
            {children}
        </VideoContext.Provider>
    );
};

export const useVideo = () => {
    const context = useContext(VideoContext);

    if (!context) {
        throw new Error("useVideo deve ser usado dentro do VideoProvider");
    }

    return context;
};